import React, { Component } from 'react';
import { Meteor } from 'meteor/meteor';
import { get, isEqual } from 'lodash';
import PropTypes from 'prop-types';
import { Button, Form, InputGroup } from 'react-bootstrap';

import { featurePoint2LatLng, featureGetZoom } from '../../../modules/geojson-utilities';

import LeafletMap from '../../components/LeafletMap';

let addOnlineBaseMap;
let getMapCenter;
let moveProjectLocation;
let searchLocation;

class MapContainerProjectEditor extends Component {
  state = {
    searchLoc: '',
    clientModulesReady: false,
    isLeafletMapLoaded: get(this, 'projectMapComponent.current.state.isMapLoaded', false),
    isProjectMapLoaded: false
  };

  projectMapComponent = React.createRef();

  projectMap = null;

  componentDidMount() {
    const { clientModulesReady } = this.state;
    if (!clientModulesReady) {
      this.loadClientModules();
    }
  }

  componentDidUpdate(prevProps) {
    const { clientModulesReady, isLeafletMapLoaded, isProjectMapLoaded } = this.state;
    const { location: prevLocation } = prevProps;
    const { location } = this.props;
    if (clientModulesReady && isLeafletMapLoaded && !isProjectMapLoaded) {
      this.initializeMap();
    }
    if (isProjectMapLoaded && !isEqual(prevLocation, location)) {
      this.projectMap.setView(
        featurePoint2LatLng(getMapCenter({ location })),
        featureGetZoom(location)
      );
    }
  }

  updateMapState = newState => {
    this.setState({ isLeafletMapLoaded: newState });
  };

  handleChangeProjectLoc = event => {
    this.setState({ searchLoc: event.target.value });
  };

  initializeMap = () => {
    const { location, onLocationChange } = this.props;
    this.projectMap = get(this, 'projectMapComponent.current.leafletMap');
    this.projectMap.setView(
      featurePoint2LatLng(getMapCenter({ location })),
      featureGetZoom(location)
    );
    addOnlineBaseMap(this.projectMap);
    moveProjectLocation({ leafletMap: this.projectMap, onLocationChange });
    this.setState({ isProjectMapLoaded: true });
  };

  handleEnterKeyPress = event => {
    const { searchLoc } = this.state;
    if (event.key === 'Enter') {
      searchLocation({ searchLoc, leafletMap: this.projectMap });
    }
  };

  async loadClientModules() {
    if (Meteor.isClient) {
      ({ addOnlineBaseMap, getMapCenter, moveProjectLocation, searchLocation } = await import(
        '../../../modules/leaflet-operations'
      ));
      this.setState({ clientModulesReady: true });
    }
  }

  render() {
    const { searchLoc } = this.state;
    const { deployEnv } = this.props;

    return (
      <>
        <LeafletMap
          mapId="projectMap"
          ref={this.projectMapComponent}
          hasSearchItem
          updateMapState={this.updateMapState}
          deployEnv={deployEnv}
        />
        <Form.Group className="my-0">
          <InputGroup>
            <Form.Control
              name="searchLoc"
              value={searchLoc}
              onKeyPress={event => this.handleEnterKeyPress(event)}
              onChange={this.handleChangeProjectLoc}
            />
            <InputGroup.Append>
              <Button
                variant="outline-secondary"
                onClick={() => searchLocation({ searchLoc, leafletMap: this.projectMap })}
              >
                Search
              </Button>
            </InputGroup.Append>
          </InputGroup>
        </Form.Group>
      </>
    );
  }
}

MapContainerProjectEditor.propTypes = {
  location: PropTypes.object.isRequired,
  onLocationChange: PropTypes.func.isRequired,
  deployEnv: PropTypes.string.isRequired
};

export default MapContainerProjectEditor;
